"use strict";
var approveScannerConditions= (function () {

    var approveForm = $('.approve-scannerconditions');
		
    if (approveForm.length > 0) {

        var approveBtn = $('.btn', approveForm),
		    approveCheckbox = $('input:checkbox', approveForm),
			cl = new CanvasLoader('loader');
			
        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#ffffff');
        cl.setFPS(24);
        

        approveForm.on('click', '.btn', approveConditions);
    }

    function approveConditions(e) {
        e.preventDefault();
        approveBtn.attr("disabled", "disabled");
        cl.show();
        var data = {
            "pageid": SETTINGS.pageid,
            "language": SETTINGS.language,
            "approved": approveCheckbox.is(":checked")
        };

        var ajaxRequest = $.ajax({
            url: SETTINGS.services.forms.methods.approveScannerConditions,
            type: "POST",
            timeout: 20000,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            document.location = document.location.href.replace("?a=6", "");
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            cl.hide();
            approveBtn.removeAttr("disabled");

        }
    }
})();
